import React, { useMemo, useState } from "react"
import Select from "react-select"
import { sportChoices } from "./eventCreationForm"
import { foldLocationText, toLocationOption } from "./eventLocationOptions"
import { withFloatingSurface } from "components/Common/selectSurface"

const pairs = options => (options || []).map(item => [String(item.key), item.name])
const completion = [["none", "None"], ["partial", "Incomplete"], ["partialWithoutFinal", "Complete without finals"], ["complete", "Complete"]]
export function DirectorySelect({ name, label, value, options, onChange, all = true }) {
  return <label className="event-filter" htmlFor={"events-" + name}><span>{label}</span>
    <select id={"events-" + name} className="form-control" value={value || ""} onChange={e => onChange(e.target.value)}>
      {all && <option value="">All</option>}
      {options.map(([key, text]) => <option value={key} key={key}>{text}</option>)}
    </select>
  </label>
}
export default function EventsFilter({ settings = {}, filters, setFilters, eventsLocations = [] }) {
  const [locationSearch, setLocationSearch] = useState("")
  const field = (name, label, options) => <DirectorySelect key={name} {...{ name, label, options }} value={filters[name]}
    onChange={value => setFilters({ ...filters, [name]: value })} />
  const year = new Date().getFullYear()
  const years = Array.from({ length: year + 4 - 2020 }, (_, i) => [String(year + 3 - i), String(year + 3 - i)])
  if (filters.year && !years.some(([key]) => key === filters.year)) years.push([filters.year, filters.year])
  const locations = useMemo(() => [...new Map(eventsLocations.map(toLocationOption).filter(Boolean).map(item => [item.value, item])).values()], [eventsLocations])
  const selectedLocation = locations.find(item => item.value === filters.location) || (filters.location ? { value: filters.location, label: filters.location } : null)
  const needle = foldLocationText(locationSearch.trim())
  const locationOptions = needle.length < 2 ? [] : locations.filter(item => foldLocationText(item.label).includes(needle)).slice(0, 100)
  const secondary = ["level", "gameType", "status", "gender", "month", "year", "scoresCompletion", "pointsSaved", "playMode"].filter(k => filters[k]).length
  return <div>
    <div className="event-filter-grid">
      {/* The event creation's Sport choices, Tenis10 among them (P43); the list reads each as its sport and programme. */}
      {field("sportType", "Sport", sportChoices(settings).map(({ key, name }) => [key, name]))}
      <label className="event-filter" htmlFor="events-location"><span>Location</span>
        <Select inputId="events-location" value={selectedLocation} options={locationOptions} placeholder="All locations"
          isClearable onInputChange={setLocationSearch} onChange={value => setFilters({ ...filters, location: value?.value || "" })}
          noOptionsMessage={() => needle.length < 2 ? "Type 2 characters to find a location" : "No matching locations"}
          styles={withFloatingSurface({ control: base => ({ ...base, minHeight: 44, height: 44 }), menu: base => ({ ...base, zIndex: 5 }) })} />
      </label>
      {field("category", "Category", pairs(settings.categories))}
    </div>
    <details className="event-more-filters" open={secondary > 0 ? true : undefined}>
      <summary>More filters{secondary ? " (" + secondary + ")" : ""}</summary>
      <div className="event-filter-grid">
        {field("level", "Level", pairs(settings.levels))}
        {field("gameType", "Game type", pairs(settings.gameTypes))}
        {field("status", "Event status", [["ACCEPTED", "Accepted"], ["CONFIRMED", "Confirmed"], ["CREATED", "Created"], ["PENDING", "Pending"], ["DISABLED", "Disabled"]])}
        {field("gender", "Gender", pairs(settings.genders))}
        {field("month", "Month", Array.from({ length: 12 }, (_, i) => [String(i + 1), new Date(2000, i).toLocaleString("en", { month: "long" })]))}
        {field("year", "Year", years)}
        {field("scoresCompletion", "Scores", completion)}
        {field("pointsSaved", "Points", completion.filter(([value]) => value !== "partialWithoutFinal"))}
        {field("playMode", "Format", pairs(settings.playModes))}
      </div>
    </details>
  </div>
}
